<template>
   <vue-final-modal
      v-model="selectInit" 
      classes="modal-container"
      content-class="select-initiator-modal-content"
      @opened="opened()"
      @click-outside="$emit('cancel')"
      >
      <button 
         id="first"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="$emit('cancel')"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">
         <div class="row m-0">
            <div class="col-11">Seleccionar inicio de tarjeta </div>
            <card-rectangle :rectangleCard="cardType" class="col-1 mt-1"/>
         </div>
      </span>
      <div class="multi-card p-0 mt-1 border-top border-bottom">
         <div class="container">
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('last').focus()"></div>
            <div class="row p-0 py-1 ms-1 tj-foot-cell"
                  @click="sendSelect('AFL')"
                  >
               <div class="col-12"><b>Inicia Afiliado</b></div>
            </div>
            <!--
            <div v-if="selectInitiator == 'SEL'" class="row p-0 py-1 ms-1 tj-foot-cell"
            -->
            <div class="row p-0 py-1 ms-1 tj-foot-cell"
                  @click="sendSelect('MPV')"
                  >
               <div class="col-12"><b>Inicia Prestador</b></div>
            </div>
            <!--
            <div v-else class="row p-0 py-1 ms-1 tj-foot-cell"
            -->
            <div class="row p-0 py-1 ms-1 tj-foot-cell"
                  @click="sendSelect('MCA')"
                  >
               <div class="col-12"><b>Inicia Prestador con notificación al Afiliado</b></div>
            </div>
            <!--
            <div v-for="(rectangleCard, index) in cellCards" :key="index" 
                  class="row p-0 py-1 ms-1 tj-foot-cell"
                  @click="sendSelect(index)"
                  >
               <card-rectangle :rectangleCard="rectangleCard"  class="col-2"/>
               <div class="col-10"><b>{{rectangleCard.name}}</b></div>
                  
            </div>
            -->
         </div>
      </div>
            <div class="row p-0 justify-content-between mx-0">
               <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
               <div class="d-flex justify-content-end pt-2 px-0 col-10">
                  <button type="button" 
                        id="last"
                        :tabindex="tabIndexNumber(3)" 
                        class="btn btn-outline-light btn-sm me-1" 
                        @click="$emit('cancel')"
                        >
                     Salir
                  </button>
                  <div :tabindex="tabIndexNumber(4)" onfocus="document.getElementById('first').focus()"></div>
               </div>
            </div>
   </vue-final-modal>
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex'

import WspService from '../../workSpace.service';

import UserCircle from '../../../../components/UserCircle.vue';
import CardRectangle from '../CardRectangle.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal,
      CardRectangle
   },

   props: {
      selectInitiator: String,
      cardType: Object
   },

   emits: [ 'cancel', 'selected' ],

   setup(props, { emit }) {

      const initialTabIndex = ref(100)
      const selectInit = ref(true)
      const myCircle = ref({})
      const store = useStore()

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      function opened() {
         
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })
      }

      function sendSelect( index ) {
         emit( 'selected', index)
         nextTick(() => {
            emit('cancel')
         })
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      
      return {
         myCircle,
         opened,
         selectInit,
         sendSelect,
         tabIndexNumber,
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.select-initiator-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.multi-card {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.tj-foot-cell {
   cursor: pointer;
}
.tj-foot-cell:hover {
   background-color: darkgrey;
}
</style>
